<template>
  <div class="mt-1 px-3">
    <v-checkbox color="primary" v-model="optIn">
      <template slot="label">
        <span
          style="color: #0000008A !important"
          v-html="text"
          @click.stop="
            () => {
              optIn === optIn;
            }
          "
        ></span>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
export default {
  props: ['text', 'value'],

  data() {
    return {
      optIn: false,
    };
  },

  mounted() {
    if (this.value === 'C') this.optIn = true;
    else if (this.value === 'U') this.optIn = false;

    this.$store.commit('SET_OPT_IN', this.optIn);
  },

  watch: {
    optIn(v) {
      this.$store.commit('SET_OPT_IN', v);
    },
  },
};
</script>
